import { useTagsView } from '@/hooks/web/useTagsView'

export function handleNavigation(router: Router, targetName: string) {
  const { getVisitedViews, delCachedView } = useTagsView()
  const visitedViews = getVisitedViews()

  const found = visitedViews.some((item) => {
    // 如果在tags中存在列表，则跳转到列表，否则跳转到上一页
    if (item.name === targetName) {
      delCachedView(item)
      router.push({
        name: item.name
      })
      return true
    }
    return false
  })

  if (!found) {
    router.go(-1)
  }
}

export function handleCloseCurrentTab(currentRoute: any) {
  const { delCachedView, closeCurrent } = useTagsView()
  delCachedView(currentRoute)
  closeCurrent(currentRoute)
}
